import React from 'react';
import { Globe } from 'lucide-react';

interface SponsorData {
  name: string;
  logo: string;
  description: string;
  contribution: string;
  website: string;
}

interface MainSponsorProps {
  sponsor: SponsorData;
}

export default function MainSponsor({ sponsor }: MainSponsorProps) {
  return (
    <div className="bg-secondary-light py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white p-8 md:p-12 rounded-xl shadow-lg">
            <div className="flex flex-col items-center">
              <img 
                src={sponsor.logo} 
                alt={sponsor.name}
                className="h-24 md:h-32 object-contain mb-8"
              />
              <h2 className="text-3xl font-bold text-primary mb-4">{sponsor.name}</h2>
              <p className="text-xl text-gray-600 mb-6 text-center">{sponsor.description}</p>
              <p className="text-lg text-primary mb-8">{sponsor.contribution}</p>
              <a 
                href={sponsor.website}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-primary hover:bg-primary-dark text-white px-8 py-3 rounded-lg transition-colors inline-flex items-center"
              >
                <Globe className="h-5 w-5 mr-2" />
                Visitar sitio web
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}